import React from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IconLeft, IconRight } from '@/assets';
import { Buttons } from '@/components';
import MarketPlaceCard from '@/contents/marketplace/MarketPlaceCard';
import { useRouter } from '@/provider/RouterProvider';
import type { NftMarket } from '@/types';

const ListTrendType: React.FC<{
  list: NftMarket[];
  title: string;
  urlCategory?: string;
}> = ({ list, title, urlCategory }) => {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const router = useRouter();

  return (
    <div className="mb-10 last:mb-0">
      <div className="mb-5 flex items-center justify-between">
        <h4 className="text-[28px] font-semibold text-black md:text-[18px]">{title}</h4>
        {urlCategory && (
          <Buttons onClick={() => router.push(urlCategory)} typeBtn="cancel">
            View category
          </Buttons>
        )}
      </div>
      <div className="group/swiper relative -mx-3">
        <Swiper
          breakpoints={{
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2.5,
            },
            1024: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 5,
            },
            1500: {
              slidesPerView: 6,
            },
          }}
          className="!px-3 !pb-[14px]"
          spaceBetween={16}
          modules={[Navigation]}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          loop
          onBeforeInit={(swiper: any) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
        >
          {list.map((asset) => (
            <SwiperSlide key={asset.id}>
              <MarketPlaceCard nftMarket={asset} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className="absolute left-0 top-[50%] z-[1] flex h-[48px] w-[48px] -translate-x-[10px] -translate-y-[50%] cursor-pointer items-center justify-center rounded-[50%] border-1 border-black bg-white opacity-0 transition-all hover:opacity-80 group-hover:translate-x-0 group-hover/swiper:opacity-100 sm:translate-x-0 sm:opacity-100"
          ref={navigationPrevRef}
        >
          <IconLeft />
        </div>
        <div
          className="absolute right-0 top-[50%] z-[1] ml-2 flex h-[48px] w-[48px] -translate-y-[50%] translate-x-[10px] cursor-pointer items-center justify-center rounded-[50%] border-1 border-black bg-white opacity-0 transition-all hover:opacity-80 group-hover:translate-x-0 group-hover/swiper:opacity-100 sm:translate-x-0 sm:opacity-100"
          ref={navigationNextRef}
        >
          <IconRight />
        </div>
      </div>
    </div>
  );
};

export default ListTrendType;
